<script lang="ts">
    import RewardsAmountFormatter from "@apps/rewards/lib/RewardsAmountFormatter/RewardsAmountFormatter";
    import RewardsCurrencyFormatter from "@apps/rewards/lib/RewardsCurrencyFormatter";
    import type { TranslationNamespaces } from "@apps/rewards/types";

    import T from "@components/T.svelte";

    import RewardsCurrency from "../RewardsCurrency.svelte";
    import HTMLSanitizerInterface from "@modules/money/HTMLSanitizer/HTMLSanitizerInterface";

    //Props
    export let storeCredits: number;
    export let amount: number;
    export let namespace: TranslationNamespaces;
    export let currencyFormatter: RewardsCurrencyFormatter;
    export let sanitizer: HTMLSanitizerInterface;
</script>

<RewardsCurrency let:amount {amount} {currencyFormatter} {sanitizer}>
    <T
        {namespace}
        translationKey="store_credits_amount_reward"
        translationOptions={{
            value: storeCredits,
            amount,
        }}
    />
</RewardsCurrency>
